import { render, staticRenderFns } from "./ykFormItem.vue?vue&type=template&id=0ad700c5&scoped=true"
import script from "./ykFormItem.vue?vue&type=script&lang=js"
export * from "./ykFormItem.vue?vue&type=script&lang=js"
import style0 from "./ykFormItem.vue?vue&type=style&index=0&id=0ad700c5&scoped=true&lang=scss"
import style1 from "./ykFormItem.vue?vue&type=style&index=1&id=0ad700c5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad700c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad700c5')) {
      api.createRecord('0ad700c5', component.options)
    } else {
      api.reload('0ad700c5', component.options)
    }
    module.hot.accept("./ykFormItem.vue?vue&type=template&id=0ad700c5&scoped=true", function () {
      api.rerender('0ad700c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykFormItem.vue"
export default component.exports